import {
  httpGet,
  httpNoAuthGet,
  httpNoAuthPost,
  httpPost,
  httpPut,
  httpDelete,
  httpUploadFormData,
} from "../utils/http";
import axios from "axios";

export default class {
  apiEndpoint = null;

  constructor(apiEndpoint) {
    this.apiEndpoint = apiEndpoint;
  }

  getVersion() {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/basic/version`;
    return httpNoAuthGet(apiUrl);
  }

  async login(username, password) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/basic/login`;

    let res = await httpNoAuthPost(apiUrl, { username, password });
    if (res.result && res.result.jwt) {
      console.log("write jwt to sessionStorage");
      localStorage.setItem("JWT", res.result.jwt);

      if (
        res.result.raw &&
        res.result.raw.clinicRoles &&
        res.result.raw.clinicRoles.length === 1
      ) {
        localStorage.setItem("CLINIC", res.result.raw.clinicRoles[0].clinic);
        console.log(
          `set operate clinic:${res.result.raw.clinicRoles[0].clinic}`
        );
      }
    }
    return Promise.resolve(res);
  }

  verify() {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/basic/verify`;
    const jwt = localStorage.getItem("JWT");
    return httpNoAuthPost(apiUrl, { jwt });
  }
}
